import React from "react";
import { useTranslation } from "react-i18next";
import { Eyebrow } from "../components/ui.jsx";
import { useCurrentLocale } from "../lib/useLocaleNav.js";
import { wireLinkStyles } from "./Privacy.jsx";

export default function TermsOfSale() {
  const { t } = useTranslation();
  const locale = useCurrentLocale();
  const orderList = t("legal.termsOfSale.orderList", { returnObjects: true });
  const durationList = t("legal.termsOfSale.durationList", { returnObjects: true });
  const priceList = t("legal.termsOfSale.priceList", { returnObjects: true });
  const useList = t("legal.termsOfSale.useList", { returnObjects: true });
  const supportList = t("legal.termsOfSale.supportList", { returnObjects: true });
  const liabList = t("legal.termsOfSale.liabList", { returnObjects: true });
  const termList = t("legal.termsOfSale.termList", { returnObjects: true });
  const termList2 = t("legal.termsOfSale.termList2", { returnObjects: true });
  const dataList = t("legal.termsOfSale.dataList", { returnObjects: true });
  const dataObList = t("legal.termsOfSale.dataObList", { returnObjects: true });
  const finalList = t("legal.termsOfSale.finalList", { returnObjects: true });

  return (
    <main>
      <section className="bg-wash">
        <div className="container" style={{ padding: "56px 24px 56px", maxWidth: 880 }}>
          <Eyebrow>{t("legal.eyebrow")}</Eyebrow>
          <h1 className="tt-h tt-h-xl" style={{ marginTop: 24 }}>{t("legal.termsOfSale.title")}</h1>
          <Html as="p" style={prose} html={t("legal.termsOfSale.intro")} />
        </div>
      </section>

      <section style={{ padding: "8px 0 120px" }}>
        <div className="container" style={{ maxWidth: 820 }}>

          <Html as="p" style={prose} html={t("legal.termsOfSale.company")} />

          <H2>{t("legal.termsOfSale.definitionsH")}</H2>
          <Html as="p" style={prose} html={t("legal.termsOfSale.definitionsIntro")} />
          <Html as="p" style={prose} html={t("legal.termsOfSale.definitionsSubscription")} />
          <Html as="p" style={prose} html={t("legal.termsOfSale.definitionsClient")} />
          <Html as="p" style={prose} html={t("legal.termsOfSale.definitionsOrder")} />
          <Html as="p" style={prose} html={t("legal.termsOfSale.definitionsAccount")} />
          <Html as="p" style={prose} html={t("legal.termsOfSale.definitionsContract")} />
          <Html as="p" style={prose} html={t("legal.termsOfSale.definitionsPackage")} />
          <Html as="p" style={prose} html={t("legal.termsOfSale.definitionsNfc")} />

          <H2>{t("legal.termsOfSale.descH")}</H2>
          <Html as="p" style={prose} html={t("legal.termsOfSale.descP1")} />
          <Html as="p" style={prose} html={t("legal.termsOfSale.descP2")} />

          <H2>{t("legal.termsOfSale.orderH")}</H2>
          <ul style={listStyle}>
            {orderList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>
          <ul style={listStyle}>
            <Html as="li" html={t("legal.termsOfSale.orderConsent", { locale })} />
          </ul>
          <ul style={listStyle}>
            <Html as="li" html={t("legal.termsOfSale.orderNote")} />
          </ul>

          <H2>{t("legal.termsOfSale.durationH")}</H2>
          <ul style={listStyle}>
            {durationList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.termsOfSale.priceH")}</H2>
          <ul style={listStyle}>
            {priceList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.termsOfSale.useH")}</H2>
          <ul style={listStyle}>
            {useList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.termsOfSale.supportH")}</H2>
          <ul style={listStyle}>
            {supportList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.termsOfSale.liabH")}</H2>
          <ul style={listStyle}>
            {liabList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.termsOfSale.termH")}</H2>
          <Html as="p" style={prose} html={t("legal.termsOfSale.termIntro")} />
          <ul style={listStyle}>
            {termList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>
          <ul style={listStyle}>
            {termList2.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.termsOfSale.dataH")}</H2>
          <ul style={listStyle}>
            {dataList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H3>{t("legal.termsOfSale.dataObH")}</H3>
          <ul style={listStyle}>
            {dataObList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.termsOfSale.finalH")}</H2>
          <ul style={listStyle}>
            {finalList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.termsOfSale.contactH")}</H2>
          <Html as="p" style={prose} html={t("legal.termsOfSale.contactP")} />
        </div>
      </section>
    </main>
  );
}

function Html({ as: Tag = "p", html, style, className }) {
  return <Tag style={style} className={className} dangerouslySetInnerHTML={{ __html: wireLinkStyles(html) }} />;
}

const prose = {
  marginTop: 16,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760
};

const listStyle = {
  marginTop: 12,
  paddingLeft: 22,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760,
  display: "flex",
  flexDirection: "column",
  gap: 10
};

function H2({ children }) {
  return (
    <h2
      className="tt-h tt-h-md"
      style={{ marginTop: 56, scrollMarginTop: 96 }}
    >
      {children}
    </h2>
  );
}

function H3({ children }) {
  return (
    <h3
      style={{
        marginTop: 32,
        fontFamily: "Satoshi, Inter, sans-serif",
        fontSize: 19,
        fontWeight: 700,
        letterSpacing: "-.012em",
        color: "var(--ink)"
      }}
    >
      {children}
    </h3>
  );
}
